module.exports = __webpack_public_path__ + "propostas.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/icons/propostas.png
 ** module id = 757
 ** module chunks = 0
 **/